export default __webpack_public_path__ + "static/media/new-feature.old.3c29a29a.svg";